import { getMediaPath } from 'app/functions';
import CircleShadow from 'assets/icons/club-strip/circle-shadow.svg';
import React from 'react';
import './index.scss';

const Circle = (props) => {
    const { icon, title, subtitle } = props; 
    return (
    <div className='circle-wrapper'>
        <div className="circle">
            <img src={getMediaPath(CircleShadow)} alt="" className="shadow" />
            <img src={getMediaPath(icon)} alt="/" className="icon" />
        </div>
        <div className="title">{title}</div>
        <div className="subtitle">{subtitle}</div>
    </div>);
}

export default Circle;